import DatePickerRange from './src/date-picker-range.vue'
import { withInstall } from '@el-plus/utils/with-install'

export const EpDatePickerRange = withInstall(DatePickerRange)
export default EpDatePickerRange
export * from './src/date-picker-range'
